import { render } from "./EscalatedUserClientsPosts.vue?vue&type=template&id=c2a6749a&ts=true"
import script from "./EscalatedUserClientsPosts.vue?vue&type=script&lang=ts"
export * from "./EscalatedUserClientsPosts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__